import {NonNavigatableBreadcrumb} from './breadcrumbs/non-navigatable-breadcrumb';
import {NavigatableBreadcrumb} from './breadcrumbs/navigatable-breadcrumb';
import {IBreadcrumb} from './breadcrumbs/breadcrumb.interface';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {UriPath} from "../location/uri-path/uri-path";

export class SiteMapNode {
  constructor(private _title: string, private _url: string, children: any[]) {
    this._loadChildren(children);
    this._urlParts = new UriPath(_url).toArray();
  }

  private readonly _urlParts: string[];

  private _loadChildren(children: any[]): void {
    this._children = (children || []).map(ch => new SiteMapNode(ch.title, ch.url, ch.children));
  }


  private _children: SiteMapNode[] = [];
  get children(): SiteMapNode[] {
    return this._children;
  }

  createBreadcrumbs(requestedUrlParts: string[], services: IServiceFactoryExtended): IBreadcrumb[] {

    for(let i = 0; i < this._urlParts.length; i++) {
      if(this._urlParts[i] !== requestedUrlParts[i]) {
        return [];
      }
    }

    if(this._urlParts.length === requestedUrlParts.length) {
      return [new NonNavigatableBreadcrumb(this._title)] //it means this is the last breadcrumb
    } else {
      let breadcrumb = new NavigatableBreadcrumb(this._title, this._url, services);

      return [breadcrumb, ...this._createChildrenBreadcrumbs(requestedUrlParts, services)];
    }
  }

  private _createChildrenBreadcrumbs(requestedUrlParts: string[], services: IServiceFactoryExtended): IBreadcrumb[] {
    for(let i = 0; i < this.children.length; i++) {
      let childBreadcrumbs = this.children[i].createBreadcrumbs(requestedUrlParts, services);
      if(childBreadcrumbs.length > 0) {
        return childBreadcrumbs;
      }
    }
    return [];
  }

  toFlatSiteMap(): {[key: string]: SiteMapNode} {
    let result = {};
    result[this._url] = this;

    this.children.forEach(child => {
      result = Object.assign(result, child.toFlatSiteMap());
    });

    return result;

  }
}
